// Auto-generated from strings.properties
// Do not edit this file directly - edit strings.properties instead
const propertiesContent = `# Customise this file, and remove any keys that you don't need.

home.title=ELISA Builder
home.subtitle=ELISA Builder makes it easy to find the best solution for developing your own ELISA assay. Based on a short list of questions about your experimental needs, the ELISA Builder tool recommends everything needed to perform an ELISA, from plates to stop solution.

home.about.title=Find your optimal set of ELISA reagents
home.about.get_started=Get started

quiz.previous=Previous step
quiz.next=Next step
quiz.submit=Submit
quiz.edit=Edit
quiz.skip=Skip
quiz.unsure=Unsure?
quiz.modal.link_title=Unsure on the ELISA types?
quiz.modal.link=Learn more
quiz.modal.title=ELISA types
quiz.modal.direct=Direct Assay
quiz.modal.indirect=Indirect Assay
quiz.modal.capture=Capture Assay "Sandwich"
quiz.modal.body=<strong>Diagram of common ELISA formats (direct vs. sandwich assays)</strong>. In the assay, the antigen of interest is immobilized by direct adsorption to the assay plate or by first attaching a capture antibody to the plate surface. Detection of the antigen can then be performed using an enzyme-conjugated primary antibody (direct detection) or a matched set of unlabeled primary and conjugated secondary antibodies (indirect detection).

quiz.q1.label=Detection method
quiz.q1.text=Which detection method do you prefer?
quiz.q1.colorimetric=Colorimetric
quiz.q1.colorimetric.tooltip=Most common method. Quantitation is measured by absorbance.
quiz.q1.fluorescent=Fluorescent
quiz.q1.fluorescent.tooltip=Provides large, dynamic range. Used with fluorescent conjugates or fluorescent substrates.
quiz.q1.chemiluminescent=Chemiluminescent
quiz.q1.chemiluminescent.tooltip=Most sensitive detection method with large, dynamic range

quiz.q2.label=Plate format
quiz.q2.text=Which ELISA plate format do you prefer?
quiz.q2.96_well=96-well plate
quiz.q2.96_well_8_well_inserts=96-well plate with 8-well strip inserts
quiz.q2.96_well_8_well_inserts.tooltip=8-well strips can be removed from a rigid 96-well frame. Ideal for partial-plate assays. Format not available for every pre-coating.
quiz.q2.384_well=384-well plate

quiz.q3.label=ELISA type
quiz.q3.text=Which ELISA type do you prefer?
quiz.q3.sandwich=Sandwich ELISA
quiz.q3.sandwich.tooltip=Target analyte is captured between two primary antibodies, each detecting a different epitope of the antigen
quiz.q3.direct=Direct ELISA
quiz.q3.direct.tooltip=Target analyte is immobilized on the plate and detected using a conjugated primary antibody
quiz.q3.indirect=Indirect ELISA
quiz.q3.indirect.tooltip=Target analyte is immobilized on the plate and detected using an unconjugated primary antibody, followed by a conjugated secondary antibody

quiz.q4.label=Coating method
quiz.q4.text.a=How will your capture antibody bind to the plate?
quiz.q4.text.b=How will your target analyte bind to the plate?
quiz.q4.coat_antibody_directly_a=Coat antibody directly to plate
quiz.q4.coat_antibody_directly_a.tooltip=Most common. Antibody adsorbs to the plate through hydrophobic interactions between non-polar residues and the polystyrene surface.
quiz.q4.coat_antibody_directly_b=Coat antibody directly to plate
quiz.q4.biotinylated_streptavidin_neutravidin_a=Biotinylated, will bind to streptavidin/NeutrAvidin-treated plate
quiz.q4.biotinylated_streptavidin_neutravidin_a.tooltip=Offers better binding capacity than traditional adsorption. Not compatible with biotinylated detection antibodies.
quiz.q4.biotinylated_streptavidin_neutravidin_b=Biotinylated, will bind to streptavidin/NeutrAvidin-treated plate
quiz.q4.biotinylated_streptavidin_neutravidin_b.tooltip=Offers enhanced binding capacity. Ideal for hydrophilic proteins or peptides. Not compatible with biotinylated detection antibodies.
quiz.q4.goat_anti_mouse_igg_a=Binds to goat anti-mouse IgG-treated plate
quiz.q4.goat_anti_mouse_igg_a.tooltip=Ideal when capture antibodies are in low quantities or become denatured (inactive) upon adsorption to plate
quiz.q4.goat_anti_mouse_igg_b=Binds to goat anti-mouse IgG-treated plate
quiz.q4.unsure=Unsure/Skip
quiz.q4.coat_analyte_directly_a=Coat analyte directly to plate
quiz.q4.coat_analyte_directly_b=Coat analyte directly to plate
quiz.q4.coat_analyte_directly_b.tooltip=Proteins or peptides are adsorbed to the plate through hydrophobic interactions between non-polar residues and the polystyrene surface
quiz.q4.his_nickel_a=His-tagged, will bind to nickel-treated plate
quiz.q4.his_nickel_b=His-tagged, will bind to nickel-treated plate
quiz.q4.his_nickel_b.tooltip=Ideal for lysates or complex protein mixtures
quiz.q4.his_copper_a=His-tagged, will bind to copper-treated plate
quiz.q4.his_copper_b=His-tagged, will bind to copper-treated plate
quiz.q4.his_copper_b.tooltip=Ideal for purified His-tagged proteins or peptides
quiz.q4.gst_glutathione_a=GST-tagged, will bind to a glutathione-treated plate
quiz.q4.gst_glutathione_b=GST-tagged, will bind to a glutathione-treated plate
quiz.q4.gst_glutathione_b.tooltip=Ideal for GST-tagged analytes
quiz.q4.sulfhydryl_maleimide_a=Sulfhydryl functional group will bind a maleimide-activated plate
quiz.q4.sulfhydryl_maleimide_b=Sulfhydryl functional group will bind a maleimide-activated plate
quiz.q4.sulfhydryl_maleimide_b.tooltip=Forms a covalent bond with sulfhydryl groups in the target analyte
quiz.q4.amine_maleic_anhydride_a=Amine functional group will bind a maleic anhydride-activated plate
quiz.q4.amine_maleic_anhydride_b=Amine functional group will bind a maleic anhydride-activated plate
quiz.q4.amine_maleic_anhydride_b.tooltip=Forms a covalent bond with amine groups in the target analyte

quiz.q5.label=Target abundance
quiz.q5.text=How abundant is the target analyte in your sample?
quiz.q5.high=High
quiz.q5.medium=Medium
quiz.q5.low=Low
quiz.q5.unsure=Unsure

quiz.q6.label=Detection antibody
quiz.q6.text=Which best describes your detection antibody?
quiz.q6.hrp=HRP-conjugated
quiz.q6.hrp.tooltip=Horseradish peroxidase enzyme is directly conjugated to a detection antibody
quiz.q6.ap=AP-conjugated
quiz.q6.ap.tooltip=Alkaline phosphatase enzyme is directly conjugated to a detection antibody
quiz.q6.biotinylated_hrp_streptavidin=Biotinylated + HRP-conjugated streptavidin
quiz.q6.biotinylated_hrp_streptavidin.tooltip=Provides signal amplification; biotinylated detection antibody binds to HRP-conjugated streptavidin
quiz.q6.biotinylated_ap_streptavidin=Biotinylated + AP-conjugated streptavidin
quiz.q6.biotinylated_ap_streptavidin.tooltip=Provides signal amplification; biotinylated detection antibody binds to AP-conjugated streptavidin
quiz.q6.fluorophore=Fluorophore-conjugated
quiz.q6.fluorophore.tooltip=Direct detection through fluorescence. No substrate needed.

quiz.skip_unsure=Unsure?
quiz.skip_skip=Skip

quiz.ui.edit=Edit
quiz.ui.back=Previous step
quiz.ui.next=Next step
quiz.ui.submit=Submit
quiz.ui.of=of

quiz.modal.link_title=Unsure on the ELISA types?
quiz.modal.link=Learn more
quiz.modal.title=ELISA types
quiz.modal.direct=Direct Assay
quiz.modal.indirect=Indirect Assay
quiz.modal.capture=Capture Assay “Sandwich”
quiz.modal.body=<strong>Diagram of common ELISA formats (direct vs. sandwich assays)</strong>. In the assay, the antigen of interest is immobilized by direct adsorption to the assay plate or by first attaching a capture antibody to the plate surface. Detection of the antigen can then be performed using an enzyme-conjugated primary antibody (direct detection) or a matched set of unlabeled primary and conjugated secondary antibodies (indirect detection).

results.error.no_data=Product details could not be loaded.
results.error.no_quiz=No quiz data found
results.error.complete_quiz=Please complete the quiz first.

results.title=Our recommendations
results.summary.standard=<strong>Based on your answers</strong>, we have provided a list of products and reagents that are best suited for your ELISA needs.
results.start_over_label=Start over
results.download_button=Download results
results.download_protocol=Download protocol
results.download_protocol.url=https://assets.thermofisher.com/TFS-Assets/BID/Technical-Notes/general-elisa-protocols-tech-note.pdf
results.download_pdf_label=Download PDF
results.download_xlsx_label=Download XLSX

results.preferences_label=Edit preferences

results.preferences.title=Edit preferences
results.preferences.edit=Edit
results.preferences.start_over=Start over
results.preferences.confirm=Confirm

results.add_all_to_cart=Add all products
results.catalog_no=Catalog #
results.add_to_cart=Add to cart
results.add_to_list=Save to list
results.group.best-solution=Best solution
results.group.additional-products=You may also need these products for your ELISA

#results.shared_list.log_in=Log in to add this to a list
results.shared_list.new_list.create_first=Create your first list
results.shared_list.new_list.name_placeholder=Enter list name
results.shared_list.new_list.create=Create
results.shared_list.added_confirmation=Added to 

results.product.type.plate=Plate
results.product.type.wash-buffer=Wash buffer
results.product.type.blocking-buffer=Blocker
results.product.type.streptavidin-conjugate=Streptavidin conjugate
results.product.type.substrate=Substrate
results.product.type.stop-solution=Stop solution
results.product.type.reservoir=Reagent reservoir
results.product.type.sealer=Plate sealer
results.product.type.elisa-buffer-kit=ELISA buffer kit
results.product.type.elisa-carbonate-coating-buffer=Coating buffer
results.product.type.buph-carbonate-bicarbonate-buffer-packs=Coating buffer
results.product.type.pierce-protein-free-tbs-blocking-buffer=Blocking buffer
results.product.type.blocker-bsa-10x-in-tbs=Blocker BSA
results.product.type.pierce-20x-tbs-buffer=TBS Buffer
results.product.type.pierce-20x-phosphate-buffered-saline=PBS Buffer

results.primary-antibodies=Primary Antibodies
results.primary-antibodies.placeholder=Search target, antigen
results.primary-antibodies.label=Target of interest
results.primary-antibodies.example_label=Example searches
results.secondary-antibodies=Secondary Antibodies
results.secondary-antibodies.placeholder=Search secondary
results.antibody-pairs=Matched Antibody Pairs
results.antibody-pairs.btn=View products
results.recombinant-proteins=Recombinant Proteins
results.recombinant-proteins.btn=View products

results.footer=Do you need to revise an answer?
results.footer.cta=Edit preferences

results.pdf.tool_name=ELISA Builder
results.pdf.title=Our recommendations
results.pdf.intro=<strong>Based on your answers</strong>, we have provided a list of products and reagents that are best suited for your ELISA needs.
results.pdf.table.product=Product
results.pdf.table.category=Category
results.pdf.table.unit_size=Unit size
results.pdf.table.catalog_no=Catalog number
results.pdf.table.price=Price
results.pdf.page=Page
results.pdf.page_of=of


results.pdf.product.category.plate=Plate
results.pdf.product.category.wash-buffer=Wash buffer
results.pdf.product.category.blocking-buffer=Blocker
results.pdf.product.category.streptavidin-conjugate=Streptavidin conjugate
results.pdf.product.category.substrate=Substrate
results.pdf.product.category.stop-solution=Stop solution
results.pdf.product.category.reservoir=Reagent reservoir
results.pdf.product.category.sealer=Plate sealer

results.pdf.product.category.elisa-buffer-kit=ELISA buffer kit
results.pdf.product.category.elisa-carbonate-coating-buffer=Coating buffer
results.pdf.product.category.buph-carbonate-bicarbonate-buffer-packs=Coating buffer
results.pdf.product.category.pierce-protein-free-tbs-blocking-buffer=Blocking buffer
results.pdf.product.category.blocker-bsa-10x-in-tbs=Wash buffer
results.pdf.product.category.pierce-20x-tbs-buffer=Wash buffer
results.pdf.product.category.pierce-20x-phosphate-buffered-saline=Wash buffer

results.pdf.card.primary-antibodies=Primary Antibodies
results.pdf.card.secondary-antibodies=Secondary Antibodies
results.pdf.card.antibody-pairs=Matched Antibody Pairs
results.pdf.card.antibody-pairs.link=elisa/query/*/filter/assaykit/matched+pair?persistFilters=yes
results.pdf.card.btn=View products
results.pdf.card.recombinant-proteins=Recombinant Proteins
results.pdf.card.recombinant-proteins.link=proteins/query/*/filter/application/ELISA?persistFilters=yes

results.pdf.card.primary-antibodies.link=antibody/primary/filter/application/ELISA
results.pdf.card.secondary-antibodies.link=antibody/secondary/

results.quick-order-xlsx.quick-order.title=ELISA Builder
results.quick-order-xlsx.quick-order.column.catalog_no=Catalog Number
results.quick-order-xlsx.quick-order.column.quantity=Quantity (1 to 9999)
results.quick-order-xlsx.quick-order.column.product=Product
results.quick-order-xlsx.quick-order.column.unit_size_price=Unit Size @ Price

results.quick-order-xlsx.quick-order.additional-products-separator=You may also need these products for your ELISA

results.product_not_available=Sorry, this product is not web orderable, please <a href="https://thermofisher.managed-otrs.com/external/">contact us</a>.`;
export default propertiesContent;
